import sets from '../sets';
import prefill from '../prefill';

export default prefill({
  white: {},
  brown: {},
  blond: {},
  red: {},
  black: {},

  candycane: { price: 2, set: sets.winterHairColors },
  frost: { price: 2, set: sets.winterHairColors },
  winternight: { price: 2, set: sets.winterHairColors },
  holly: { price: 2, set: sets.winterHairColors },

  pblue: { price: 2, set: sets.pastelHairColors },
  pgreen: { price: 2, set: sets.pastelHairColors },
  porange: { price: 2, set: sets.pastelHairColors },
  ppink: { price: 2, set: sets.pastelHairColors },
  ppurple: { price: 2, set: sets.pastelHairColors },
  pyellow: { price: 2, set: sets.pastelHairColors },

  rainbow: { price: 2, set: sets.rainbowHairColors },
  yellow: { price: 2, set: sets.rainbowHairColors },
  green: { price: 2, set: sets.rainbowHairColors },
  purple: { price: 2, set: sets.rainbowHairColors },
  blue: { price: 2, set: sets.rainbowHairColors },
  TRUred: { price: 2, set: sets.rainbowHairColors },

  pblue2: { price: 2, set: sets.shimmerHairColors },
  pgreen2: { price: 2, set: sets.shimmerHairColors },
  porange2: { price: 2, set: sets.shimmerHairColors },
  ppink2: { price: 2, set: sets.shimmerHairColors },
  ppurple2: { price: 2, set: sets.shimmerHairColors },
  pyellow2: { price: 2, set: sets.shimmerHairColors },

  sunset: { price: 2, set: sets.summerHairColors },
  sunlitwaves: { price: 2, set: sets.summerHairColors },
  seasprite: { price: 2, set: sets.summerHairColors },
  sandnsea: { price: 2, set: sets.summerHairColors },
  orchid: { price: 2, set: sets.summerHairColors },
  lava: { price: 2, set: sets.summerHairColors },

  candycorn: { price: 2, set: sets.hauntedHairColors },
  ghostwhite: { price: 2, set: sets.hauntedHairColors },
  halloween: { price: 2, set: sets.hauntedHairColors },
  midnight: { price: 2, set: sets.hauntedHairColors },
  pumpkin: { price: 2, set: sets.hauntedHairColors },
  zombie: { price: 2, set: sets.hauntedHairColors },

  aurora: { price: 2, set: sets.winteryHairColors },
  festive: { price: 2, set: sets.winteryHairColors },
  hollygreen: { price: 2, set: sets.winteryHairColors },
  peppermint: { price: 2, set: sets.winteryHairColors },
  snowy: { price: 2, set: sets.winteryHairColors },
  winterstar: { price: 2, set: sets.winteryHairColors },
});
